import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import store, { appraiserActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { AppraisalsApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { LoadPanel } from 'devextreme-react/load-panel';
import { RefreshEvents } from '../../../common/SharedEvents';
import { handleAdminError, handleAdminSuccess } from '../../../common/SharedFunctions';

const RestoreAppraiserModal = () => {
    const { isOpen, appraiserId = 0 } = useSelector((state) => state.appraisers.restoreAppraiserModal);
    const { dispatch } = store;
    const appraiserApi = new AppraisalsApi.AppraisalsApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const [itemName, set_itemName] = useState('');

    //Dialogs
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('Loading...');

    const handleClose = () =>
        dispatch(
            appraiserActions.setRestoreAppraiserModal({
                restoreAppraiserModal: { isOpen: false },
            })
        );

    const styles = {
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        sectionHeader: { margin: '10px 0' },
        formColumn: { paddingBottom: '5px', paddingRight: '10px' },
    };

    const resetState = () => {
        set_itemName('');
    };

    useEffect(() => {
        resetState();
    }, [isOpen]);

    useEffect(() => {
        const loadItemAsync = async () => {
            let response = null;

            if (!appraiserId || appraiserId <= 0) {
                return;
            } else {
                response = await appraiserApi.getAppraiser(appraiserId);
            }

            if (response.statusCode !== 200) {
                return;
            }
            set_itemName(response.result.displayName);
        };
        loadItemAsync();
    }, [appraiserId]);

    const restoreItem = async () => {
        try {
            set_loadingMessage('Saving changes...');
            set_loadingOpen(true);

            let response = null;

            if (!appraiserId || appraiserId <= 0) {
                return;
            } else {
                response = await appraiserApi.restoreAppraiser(appraiserId);
            }

            if (response.statusCode !== 200) {
                return;
            }

            refreshEvents.dispatchRefreshEvent();

            handleAdminSuccess('Appraiser has been restored successfully.');
            set_loadingOpen(false);

            setTimeout(() => {
                handleClose();
            }, 600);
        } catch (ex) {
            set_loadingOpen(false);
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        }
    };

    if (!isOpen || !appraiserId) {
        return null;
    }

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex='-1'
                    role='dialog'
                    style={{ width: '500px', overflow: 'unset' }}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <div
                            className='page-header'
                            role='banner'
                        >
                            <h1
                                style={{
                                    height: '50px',
                                    marginTop: '15px',
                                    flex: '0 0 80%',
                                    maxWidth: '80%',
                                }}
                            >
                                Restore Appraiser
                            </h1>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                                aria-label='Close'
                                onClick={handleClose}
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                    </div>
                    <div
                        className='main-content no-search'
                        style={{ padding: '0', margin: '0' }}
                    >
                        <div style={{ padding: '10px' }}>
                            <div className='row'>
                                <div
                                    className='columns small-12 large-12'
                                    style={styles.formColumn}
                                >
                                    Are you sure you want to restore this Appraiser? <br />
                                    <br />
                                </div>
                            </div>
                            <div className='row'>
                                <div
                                    className='columns small-12 large-12'
                                    style={styles.formColumn}
                                >
                                    <b>{itemName}</b>
                                </div>
                            </div>
                        </div>

                        <div
                            className='button-footer'
                            style={styles.buttonContainer}
                        >
                            <button
                                style={styles.buttonMarginRight}
                                type='button'
                                className='button primary'
                                title='Restore and close this form'
                                onClick={restoreItem}
                            >
                                Yes, Restore.
                            </button>
                            &nbsp;
                            <button
                                type='button'
                                className='button hollow'
                                data-dismiss='modal'
                                onClick={handleClose}
                                title='Abandon Restore and close this form'
                            >
                                No, Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </Dialog>
    );
};

export default RestoreAppraiserModal;
